<template>
    <span v-if="delivery_start">
        <span v-if="loading" style="margin-left: 3px;"><b><i class="fas fa-circle-notch fa-spin"></i> Calculando...</b></span>
        <span v-else> {{ total_distance > 0  ? total_distance.toFixed(2).replace(".", ",") + " km" : ""}}</span>
    </span>
</template>

<script>
import Api from "@/lib/Api";

export default {
    name: "ReportCalcTotalDistance",

    props: {
        fk_driver: {
            type: Number,
            require: true,
        },
        driver_document: {
            type: String,
            require: true,
        },
        license_plate: {
            type: String,
            require: true,
        },
        delivery_start: {
            type: String,
            require: true,
        },
        cargo: {
            type: String,
            require: true,
        },
        start_date: {
            type: [String, null],
            require: false,
        },
        end_date: {
            type: String,
            require: false,
        },
		show_cargo: {
			type: [Boolean, Number],
			require: false,
		}
    },

    data: function() {
        return {
            loading: true,
            positions: [],
            total_distance: 0.0,
        }
    },

    mounted: async function() {
		if (this.delivery_start != null) {
			this.loading = true;
			await this.getCargoPositions();
			this.getTotalDistance();
			this.loading = false;
		}
		this.$emit("calculated");
    },
    
    methods: {
        /**
         * Requisita os pontos da rota para o cálculo da distância
         */
        getCargoPositions: async function()
        {
			let res = null;

            let fields = {
                "fk_driver": this.fk_driver,
                "driver_document": this.driver_document,
                "license_plate": this.license_plate,
                "cargo": this.cargo,
				"start_date": this.start_date.split("/").reverse().join("-"),
				"end_date": this.end_date.split("/").reverse().join("-"),
				"show_cargo": this.show_cargo ? true : false,
            };

			try {
				res = await Api.post("report/get-cargo-positions", fields);
			} catch(ex) {
				console.log(ex);
				this.$notification.error("Não foi possível obter todas as posições da carga para cálculo.");
				return;
			}

			if (res.error) {
				this.$notification.error(res.data);
				return;
			}

            this.positions = res.data;
		},
        
        /**
         * Calcula a distânci a partir dos pontos retornados
         */
        getTotalDistance: async function() 
		{	
            // Verifica se há posições registradas para essa entrega
			if(this.positions.length > 0) 
			{
				// Inicia a lista de posição
				var positions = [];
				
				// Percorre os dados
				this.positions.forEach(async (element, index) => {
					// Armazena a posição
					positions.push(element.position);

					// Calcula a distância para a próxima posição
					let distance = 0;
					if (typeof this.positions[index + 1] != "undefined")
					{
						// Identifica o ponto de saída
						let positionFrom = {
							lat: parseFloat(element.position.split(",")[0]),
							lng: parseFloat(element.position.split(",")[1]),
						};

						// Identifica o ponto de chegada
						let positionTo = {
							lat: parseFloat(this.positions[index + 1].position.split(",")[0]),
							lng: parseFloat(this.positions[index + 1].position.split(",")[1]),
						};

						// Obtém a distância entre esses pontos
						distance = this.calcDistance(positionFrom, positionTo);
					}
					
					// Verifica se o array de pontos tem 100 elementos
					// Ou se é a última posição registrada
					// Ou se a data da próxima posição é diferente da atual
					// Ou se tem distância maior que 1 km para próxima posição
					if (((positions.length % 100) == 0) || ((index + 1) == this.positions.length) || ((typeof this.positions[index + 1].date.split(" ")[0] != "undefined") && (element.date.split(" ")[0] != this.positions[index + 1].date.split(" ")[0])) || (distance > 1)) 
					{
						// Percorre os pontos
						for(let i = 0; i < positions.length; i++)
						{
							// Verifica se não é o próximo da
							if (typeof positions[i + 1] != "undefined") 
							{
								// Identifica o ponto de saída
								let positionFrom = {
									lat: parseFloat(positions[i].split(",")[0]),
									lng: parseFloat(positions[i].split(",")[1]),
								};

								// Identifica o ponto de chegada
								let positionTo = {
									lat: parseFloat(positions[i + 1].split(",")[0]),
									lng: parseFloat(positions[i + 1].split(",")[1]),
								};

								// Adiciona a distância ao total
								this.total_distance += this.calcDistance(positionFrom, positionTo);
							}
						}
						
						// Limpa a lista de posição
						positions.length = 0;
						
						// Verifica se não é o último ponto da lista
						// Ou se a data da próxima posição é igual ao atual
						// Ou se a distância para a próxima posição for menor que 1 km
						if ((((index + 1) == this.positions.length) || ((typeof this.positions[index + 1].date.split(" ")[0] != "undefined") && (this.positions[index].date.split(" ")[0] == this.positions[index + 1].date.split(" ")[0]))) && (distance < 1)) {
							// Adiciona o ponto ao próximo trecho
							positions.push(element.position);
						}
					}
				});
			} else {
                this.total_distance = 0.0;
            }
		},

        // Calcula a longitude e latitude de dois pontos e retorna a distânca em km
		calcDistance: function(positionFrom, positionTo) {
			const R = 6371; // km
			let dLat = this.toRad(positionTo.lat - positionFrom.lat);
			let dLng = this.toRad(positionTo.lng - positionFrom.lng);
			let latFrom = this.toRad(positionFrom.lat);
			let latTo = this.toRad(positionTo.lat);

			let a = Math.sin(dLat/2) * Math.sin(dLat/2) + Math.sin(dLng/2) * Math.sin(dLng/2) * Math.cos(latFrom) * Math.cos(latTo); 
			let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a)); 
			let d = R * c;
			return d;
		},

        // Converte grau para radiano
		toRad: function(value) 
		{
			return value * Math.PI / 180;
		},
    }
}
</script>

<style scoped>
</style>